import { useCallback, useEffect, useRef, useState } from 'react';

const isScrolledPast = (ref, offset) =>
  Boolean(ref.current) &&
  window.scrollY >= ref.current.offsetTop + ref.current.offsetHeight + offset;

/**
 * Drives the collapsing candidate selection bar and header as the user scrolls.
 * Returns the refs to attach to the measured elements plus the visibility flags
 * for their collapsed counterparts. No-ops in single view.
 */
export const useScrollCollapse = ({ isSingleView, hasMultipleCounters }) => {
  const [showCollapsibleSelection, setShowCollapsibleSelection] = useState(false);
  const [showCollapsibleHeader, setShowCollapsibleHeader] = useState(false);

  const candidateSelectionRef = useRef(null);
  const candidateHeaderRef = useRef(null);

  const handleScroll = useCallback(() => {
    if (isSingleView) return;

    if (candidateSelectionRef.current) {
      setShowCollapsibleSelection(isScrolledPast(candidateSelectionRef, 5));
    }

    if (candidateHeaderRef.current) {
      setShowCollapsibleHeader(
        isScrolledPast(candidateHeaderRef, !hasMultipleCounters ? 100 : 220),
      );
    }
  }, [hasMultipleCounters, isSingleView]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return {
    showCollapsibleSelection,
    showCollapsibleHeader,
    candidateSelectionRef,
    candidateHeaderRef,
  };
};
